import { ServiceDeskArticle } from "../models/serviceDesk/ServiceDeskArticle";
import { apiCall } from "./apiClient";


export const fetchServiceDeskArticles = async(signal?: AbortSignal) => {
    const response = await apiCall<ServiceDeskArticle[]>("serviceDesk/articles", "GET", signal);
    return response.data;
};
